<crm-multi-select
  [options]="tasks"
  [(selectedItems)]="selectedTasks"
  (selectedItemsChange)="selectedTasksChange.emit($event)"
  [showToggleAll]="true"
  [virtualScroll]="true"
  [virtualScrollItemSize]="50"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [disabled]="disabled"
  scrollHeight="200px"
  [lazy]="true"
  (onLazyLoad)="searchTasks($event)"
  (onFilter)="filterTasks($event)"
  filterBy="id,responsible.name,status.name"
  [appendTo]="appendTo">
  <ng-template
    #itemTemplate
    let-task="item">
    <ng-container *ngIf="toTask(task) as task">
      <div class="w-full flex justify-content-between align-items-center white-space-normal gap-2">
        <div>
          <p class="font-bold">Заявка №{{ task.id }}</p>
          <p class="font-medium">{{ task.responsible?.name }}</p>
        </div>
        <div class="white-space-nowrap">
          <crm-status-label
            *ngIf="task.status"
            [name]="task.status.name"
            [color]="task.status.color"></crm-status-label>
        </div>
      </div>
    </ng-container>
  </ng-template>
</crm-multi-select>
